function buildId (section) {
  const order = ['country', 'zone', 'state', 'lga', 'sdp', 'name']
  return order
    .filter(key => section[key]) // only keep present fields
    .map(key => `${key}:${section[key]}`)
    .join(':')
}

function parseSection (section) {
  const parts = section.split('-')
  const result = {}

  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i]
    if (['country', 'zone', 'state', 'lga', 'sdp', 'name'].includes(key)) {
      let valueParts = []
      for (let j = i + 1; j < parts.length; j++) {
        if (['country', 'zone', 'state', 'lga', 'sdp', 'name'].includes(parts[j])) {
          break
        }
        valueParts.push(parts[j])
      }
      result[key] = valueParts.join('-')
    }
  }

  result.id = buildId(result)
  return result
}

function parseShipmentIdIntoLocationProps (shipmentId) {
  const originPart = shipmentId.split('origin:')[1].split(':destination:')[0]
  const destinationPart = shipmentId.split(':destination:')[1].split(':date:')[0]

  return {
    origin: parseSection(originPart),
    destination: parseSection(destinationPart)
  }
}

module.exports = { parseShipmentIdIntoLocationProps }
